import React from "react";
import { callParticipant } from "../../utils/contacts";

const pillStyle = { borderRadius: "1rem", padding: "0 .5rem", fontSize: "11px", whiteSpace: "nowrap", border: "1px solid" };

// "Call with Luis Diaz [Co-borrower]" above a call recording. Renders nothing for
// apps without co-borrowers, so their call history looks exactly as before.
function CallParticipant({ contacts, contactId, style }) {
    const participant = callParticipant(contacts, contactId);
    if (!participant) return null;

    return (
        <p style={{ fontSize: "12px", color: "#B1B1B1", display: "flex", alignItems: "center", gap: "6px", flexWrap: "wrap", ...style }}>
            <i className="pi pi-phone" style={{ fontSize: 10 }} />
            <span>Call with {participant.name}</span>
            {participant.role && (
                <span style={{ ...pillStyle, borderColor: participant.isCoBorrower ? "#FFB400" : "#6b6b6b", color: participant.isCoBorrower ? "#FFB400" : "#B1B1B1" }}>
                    {participant.role}
                </span>
            )}
        </p>
    );
}

export default CallParticipant;
